<template>
	<el-drawer title="我是标题" :visible.sync="drawer" direction="rtl" :before-close="handleClose">
		<span>我来啦!</span>
	</el-drawer>
</template>

<script>
	export default {
		name: 'rightDrawer',
		props: {
			drawer: {
				type: Boolean,
				default: false,
			},
			params: {
				type: Object,
				default: () => {}
			}
		},
		data() {
			return {}
		},
		mounted() {
			// console.log(this.drawer)
		},
		methods: {
			handleClose(done) {
				this.$confirm('确认关闭？')
					.then(() => {
						this.$emit('update:drawer', false)
						done();
					})
					.catch(()=> {});
			}
		}
	}
</script>

<style lang="scss" scoped>
</style>